import { type DefaultContext, mutationPromise } from '@egw/clients'
import {
  type EnrollmentIntroSubmitInput,
  type EnrollmentIntroData,
  type EnrollmentIntroSubmitOutput,
} from '../../../models'
import { createMutationHook, createQueryHook } from '../../../hooks'

export const getEnrollmentIntroData = async (context?: DefaultContext): Promise<EnrollmentIntroData> => {
  const response = (await mutationPromise(
    {
      name: 'getEnrollmentIntroData',
      query: `mutation getEnrollmentIntroData($submitEnrollmentInput: SubmitEnrollmentInput!) {
        submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
          ... on SubmitEnrollmentSuccess {
            __typename
            path
            
          }
          ... on SubmitEnrollmentError {
            __typename
            path
          }
        }
      }`,
    },
    {
      submitEnrollmentInput: {},
    },
    context,
  )) as { submitEnrollment: EnrollmentIntroData }
  return response.submitEnrollment
}

export const useGetEnrollmentIntroData = createQueryHook<undefined, EnrollmentIntroData>(getEnrollmentIntroData)

/**
 * Submit Enrollment Intro data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentIntroSubmitOutput>
 * @example const response = await submitEnrollmentIntroData();
 */
export const submitEnrollmentIntroData = async (
  enrollmentIntroSubmitInput: EnrollmentIntroSubmitInput,
  context?: DefaultContext,
): Promise<EnrollmentIntroSubmitOutput> => {
  const response = (await mutationPromise(
    {
      name: 'submitEnrollmentIntroData',
      query: `mutation submitEnrollmentIntroData($submitEnrollmentInput: SubmitEnrollmentInput!) {
        submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
          ... on SubmitEnrollmentSuccess {
            __typename
            path
          }
          ... on SubmitEnrollmentError {
            __typename
            path
          }
        }
      }`,
    },
    {
      submitEnrollmentInput: enrollmentIntroSubmitInput,
    },
    context,
  )) as { submitEnrollment: EnrollmentIntroSubmitOutput }
  return response.submitEnrollment
}

export const useSubmitEnrollmentIntroData = createMutationHook<EnrollmentIntroSubmitInput, EnrollmentIntroSubmitOutput>(
  submitEnrollmentIntroData,
)
